import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Table from 'src/components/table/Table';
import { BUSINESS_LANGUAGES } from '../../../../../common/constants';

import useConfirmationModal from '../../../../../components/modal/useConfirmationModal';
import { toggleResponsiveTableOverflowState } from 'src/helpers/utils';

const PaymentsTable = ({ onEditPayment, onDeletePayment, defaultLocale }) => {
	const [confirmAction, confirmationModal] = useConfirmationModal();

	return (
		<div className="mb-5 mb-xl-8">
			<div className="py-2">
				<Table hasBorder={true}>
					<Table.Column field="title" body={(row) => (row?.title ? row.title : row?.translations?.[defaultLocale]?.title)} sortable>
						<FormattedMessage id="LOCATIONS.PAYMENTS_TABLE.RULE" />
					</Table.Column>
					<Table.Column
						field="type"
						formatValue={(value) =>
							value === 'prepayment' ? (
								<FormattedMessage id="LOCATION.DETAILS.PREPAYMENT" />
							) : (
								<FormattedMessage id="LOCATION.SETTINGS.CHARGE_NOSHOW_FEE" />
							)
						}
					>
						<FormattedMessage id="LOCATIONS.PAYMENTS_TABLE.TYPE" />
					</Table.Column>
					<Table.Column
						field="action"
						body={(row) => (
							<Dropdown onToggle={toggleResponsiveTableOverflowState}>
								<Dropdown.Toggle variant="light" size="sm" id="store_actions_dropdown">
									<i className="bi bi-three-dots-vertical fs-4" />
								</Dropdown.Toggle>
								<Dropdown.Menu
									renderOnMount
									popperConfig={{
										strategy: 'fixed',
										modifiers: [
											{
												name: 'offset',
												options: {
													offset: [-15, -10],
												},
											},
										],
									}}
								>
									<Dropdown.Item className="btn btn-sm text-primary" onClick={() => onEditPayment(row._id)}>
										<FormattedMessage id="GENERAL.EDIT" />
									</Dropdown.Item>
									<Dropdown.Item className="btn btn-sm error-text" onClick={() => confirmAction(() => onDeletePayment(row._id))}>
										<FormattedMessage id="GENERAL.DELETE" />
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						)}
					></Table.Column>
				</Table>
				{confirmationModal}
			</div>
		</div>
	);
};

export default PaymentsTable;
